import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ColDef, GridReadyEvent } from 'ag-grid-community';
import { ApiService } from '../../../../../app/core/services/api.service';
import { LoaderService } from '../../../../../app/core/services/loading.service';
import { CustomSpinnerComponent } from '../../../../components/custom-spinner/custom-spinner.component';
import { ReportsBurstGridPopupComponent } from '../reports-burst-grid-popup/reports-burst-grid-popup.component';

@Component({
    selector: 'app-reports-burst-grid',
    templateUrl: './reports-burst-grid.component.html',
    styleUrls: ['./reports-burst-grid.component.scss'],
    standalone: false
})
export class ReportsBurstGridComponent implements OnInit {


  totalRows: any;
  // rowDataRes: any;
  title = 'Bursting demo'
  public JSON = JSON;
  gridApi: any;
  loadingOverlayComponent: any = CustomSpinnerComponent;
  paginationPageSizeNotify = 10
  paginationBarItemsPerPageNotify = 10;
  paginationPageSizeSelectorNotify: number[] = [];

  @ViewChild(ReportsBurstGridPopupComponent) reportBurstPopupComponent: ReportsBurstGridPopupComponent;

  constructor(private loaderService: LoaderService, private readonly apiService: ApiService, private router: Router) {

  }

  public gridOptions = {
    animateRows: false,
    suppressHorizontalScroll: true,
  };

  defaultColDefNotify: ColDef = {
    resizable: false,
    autoHeight: true,
    wrapText: true,
    wrapHeaderText: true,
    sortable: false,
    checkboxSelection: false
  };

  columnDefs: ColDef[] = [
    {
      headerName: 'LOCATION NAME',
      field: 'locationName',
      sortable: true,
      flex: 1,
      cellRenderer: (param) => `<a>${param.value}</a>`,
      onCellClicked: this.goToDescription.bind(this)
    },
  ]


  rowDataRes: any = []



  custReportId: any;
  rptSchBurstId: any;
  data: any
  filterValuationDate: any
  firstName = this.JSON.parse(localStorage.getItem('firstName'))
  lastName = this.JSON.parse(localStorage.getItem('lastName'))



  ngOnInit() {


    const state = history.state

    if (state) {
      this.custReportId = state['custReportId'];
      this.rptSchBurstId = state['rptSchBurstId'];
      this.filterValuationDate = state['filterValDate']
      this.data = state['data'];

      this.title = this.data.formattedName

    } else {
      console.warn('No state data found in navigation');
    }

    this.getResponse()

  }

  getApplicationId() {
    const encodedId = this.loaderService.getItem('appAccountDetailId');
    if (!encodedId) return null;

    const decodedId = encodedId;
    return Number(decodedId) === 0 ? null : decodedId;
  }

  getResponse() {

    const payload = {

      "operation": "FETCH_BURST_COMMUNICATION",
      "actionType": "MANAGE_CUSTOM_REPORTS",
      "organizationId": this.loaderService.getItem('orgId'),
      "applicationAccntDtlId": this.getApplicationId(),
      "customReport": {
        "customReportId": this.custReportId,
        "reportSchdlBurstId": this.rptSchBurstId,

        // "customReportId": 129286109,  //hardcoded for development purpose
        // "reportSchdlBurstId": 3734109566,   //hardcoded for development purpose

        "selectedFilterCriteria": {
          "filterValuationDate": this.filterValuationDate
        }
      }

    }



    this.apiService.putData('reports', payload).subscribe({
      next: (resp) => {
        this.loaderService.hideLoader();
        this.rowDataRes = resp.notificationsDataVOList
        this.totalRows = resp.notificationsDataVOList.length
        this.paginationPageSizeNotify = 10
        this.paginationPageSizeSelectorNotify = [];
        if (this.totalRows > 0) this.pageSizeOptionsNotify();
      },
      error: (error) => {
        this.loaderService.hideLoader();
      }
    })
  }


  pageSizeOptionsNotify() {
    let maxRange = this.totalRows <= 500 ? this.totalRows + 10 : 500;
    maxRange = this.checkMaxRangeNotify(maxRange);
    for (let i = 10; i <= maxRange; i += 10) {
      this.paginationPageSizeSelectorNotify.push(i);
    }
  }

  checkMaxRangeNotify(maxRange?: number) {
    if (maxRange % 10 === 0 && maxRange != 500) {
      maxRange = maxRange - 10;
    }
    return maxRange;
  }

  goToDescription(event) {
    localStorage.setItem('loctnName', event.value)
    const payload = {
      "operation": "FETCH_BURST_EMAIL_CONTENT",
      "actionType": "MANAGE_CUSTOM_REPORTS",
      "organizationId": this.loaderService.getItem('orgId'),
      "applicationAccntDtlId": this.getApplicationId(),
      "emailId": event.data.emlId
    }
    this.apiService.putData('reports', payload).subscribe({
      next: (resp) => {
        this.reportBurstPopupComponent?.showDescModal(resp.notificationsDataVO)
        this.loaderService.hideLoader();
      },
      error: (error) => {
        this.loaderService.hideLoader();
      }
    })


  }


  returnToCompletedRequests() {
    this.loaderService.setItem('reportTab', 'Completed Requests');
    this.router.navigate(['/reports']);
  }




  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
  }

}
